var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgStatistic = function SvgStatistic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19 28.8823H16C13.8437 28.8823 12 30.8806 12 32.5V48.1764C12 49.7958 13.7481 51.5813 15.9044 51.5813H19C21.1563 51.5813 22 49.7958 22 48.1764V32.5C22 30.8806 21.1563 28.8823 19 28.8823Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.5918H17C14.628 29.5918 13 32.0358 13 33.7058V49.3823C13 51.0522 14.628 52.9999 17 52.9999H20C22.372 52.9999 24 51.0522 24 49.3823V33.7058C24 32.0358 22.372 29.5918 20 29.5918Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.7052 12H30.2948C27.9229 12 26 14.2317 26 16.9846V45.6036C26 48.3565 27.9229 50.5882 30.2948 50.5882H32.7052C35.0771 50.5882 37 48.3565 37 45.6036V16.9846C37 14.2317 35.0771 12 32.7052 12Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7052 13.2061H31.2948C28.9229 13.2061 27 15.5075 27 18.3464V47.8598C27 50.6988 28.9229 53.0002 31.2948 53.0002H33.7052C36.0771 53.0002 38 50.6988 38 47.8598V18.3464C38 15.5075 36.0771 13.2061 33.7052 13.2061Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M46.0956 16.8237H43.9044C41.7481 16.8237 40 18.7929 40 21.2219V46.474C40 48.903 41.7481 50.8722 43.9044 50.8722H46.0956C48.2519 50.8722 50 48.903 50 46.474V21.2219C50 18.7929 48.2519 16.8237 46.0956 16.8237Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7052 17.8877H45.2948C42.9229 17.8877 41 19.9184 41 22.4233V48.4645C41 50.9695 42.9229 53.0002 45.2948 53.0002H47.7052C50.0771 53.0002 52 50.9695 52 48.4645V22.4233C52 19.9184 50.0771 17.8877 47.7052 17.8877Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/statistic.45ce308d.svg";
export { SvgStatistic as ReactComponent };